const isEmptyInfo = (value?: string | null) => {
  const normalized = (value || "").trim();
  return !normalized || /^-+$/.test(normalized) || /^(0|sn)$/i.test(normalized);
};

export const displayStoreInfo = (value?: string | null) =>
  isEmptyInfo(value) ? "Não informado" : (value || "").trim();

export const formatCityLabel = (city: string) =>
  (city || "")
    .trim()
    .replace(/\s+/g, " ")
    .replace(
      /\S+/g,
      (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    );

export const formatStoreAddress = (store: {
  address?: string;
  number?: string;
  district?: string;
  complement?: string;
}) => {
  const parts = [
    [store.address, store.number]
      .map((part) => (part || "").trim())
      .filter((part) => !isEmptyInfo(part))
      .join(", "),
    ...[store.district, store.complement]
      .map((part) => (part || "").trim())
      .filter((part) => !isEmptyInfo(part)),
  ].filter(Boolean);

  return parts.join(" - ") || "Endereço não informado";
};

export const hasStoreValue = (value?: string | null) => !isEmptyInfo(value);
